import { createContext } from 'react'

const AdServerMetadataContext = createContext({})

export const AdServerMetadataProvider = AdServerMetadataContext.Provider

export const withAdServerMetadataContext = Component => {
  const WithAdServerMetadataContext = props => {
    return (
      <AdServerMetadataContext.Consumer>
        {metadata => <Component {...props} metadata={metadata} />}
      </AdServerMetadataContext.Consumer>
    )
  }

  return WithAdServerMetadataContext
}
